export default Object.freeze({
  UntilChildrenFinish: 1,
  UntilChildrenCompleteSpecificAction: 2,
});
